if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"auth","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(35|443|496|673)|2(027|045|15|183|351|44|952)|5((10|31|98)9|115|433|463|552|705)|6(085|243|407|565|621)|8([46]55|069|204|677|753)|9([34]15|439)|3369|4479|4880|761)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}